import Image from 'next/image';

import { useTrackEventAmplitude } from '../../../../../core/Tracking/Amplitude/Amplitude';
import { Button } from '../../../../../design-system/components/form/button/Button';
import { HighlightPostBlockSliceType } from '../../../../../domains/Prismic/BrandPages/BrandPagesDocument';
import { EvaneosPrismicRichText } from '../../../../../domains/Prismic/EvaneosPrismicRichText';

import style from './HighlightPostBlockSlice.module.css';

export type HighlightPostBlockSliceProps = HighlightPostBlockSliceType;

export function HighlightPostBlockSlice({
    text,
    ctaLabel,
    ctaLink,
    backgroundColor,
    fontColor,
    picture,
    target,
}: HighlightPostBlockSliceProps) {
    const { trackEvent } = useTrackEventAmplitude();
    return (
        <div
            className={style.card}
            // eslint-disable-next-line react/forbid-dom-props
            style={{
                backgroundColor: backgroundColor ?? 'var(--color-green-900)',
                color: fontColor ?? 'var(--color-text-overlay)',
            }}
        >
            {picture?.url ? (
                <div className={style.imageContainer}>
                    <Image
                        className={style.image}
                        alt={picture.alt}
                        src={picture.url}
                        fill
                        loading="lazy"
                        sizes="600px"
                    />
                </div>
            ) : null}
            <div className={style.content}>
                <EvaneosPrismicRichText field={text} />
                {ctaLabel && ctaLink?.url ? (
                    <div>
                        <Button
                            priority="text"
                            reversed
                            href={ctaLink?.url}
                            target={target || undefined}
                            onClick={() => {
                                trackEvent((ampli, defaultProperties) => {
                                    ampli.highlightPostBlockClicked({
                                        ...defaultProperties,
                                    });
                                });
                            }}
                        >
                            {ctaLabel}
                        </Button>
                    </div>
                ) : null}
            </div>
        </div>
    );
}
